<template>
  <div class="singleSale">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <!-- <formItem
            ref="formItem"
            :params="baseFormData"
            :columns="filterFormColumList"
            :rules="formRules"
            @changeValueHandler="changeValueHandler"
          ></formItem> -->
          <BaseInfoContract
            ref="formItem"
            :isDisabledPricingRule="isDisabledPricingRule"
            :fetchData="baseFormData"
            :contractStatus="contractStatus"
            :contractTotalAmount="contractTotalAmount"
            :isFixedPrice="isFixedPrice"
            :disabledIsRestrict="disabledIsRestrict"
            @isRestrict="isRestrictHandler"
            @changeCompany="changeCompany"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            产品明细
          </div>
        </template>
        <div class="collapse-content">
          <!--产品明细-->
          <div class="prodcut">
            <el-tabs type="card" v-model="tabActiveName" class="common-tab">
              <el-tab-pane label="产品明细" name="first">
                <div class="detail">
                  <ShopDetailContractTable
                    :orderDetailList="orderDetailList"
                    :baseFormData="baseFormData"
                    :contractStatus="contractStatus"
                    @closeTableHandler="closeTableHandler"
                    @tableDeleteNotifier="tableDeleteNotifier"
                    @isDisabledIsRestrict="isDisabledIsRestrict"
                    :detailPageData="detailPageData"
                    :parentIsRestrict="isRestrict"
                    :companyCode="companyCode"
                    ref="contractTableRef"
                  />
                </div>
              </el-tab-pane>
              <el-tab-pane label="逾期利息" name="third">
                <div class="detail">
                  <!-- 修改为表格 -->
                  <!-- <OverdueInterest
                    ref="overdueInterestRef"
                    :orderInterest="orderInterest"
                    :contractStatus="contractStatus"
                  /> -->
                  <OverdueInterestTable
                    ref="overdueInterestTableRef"
                    :contractStatus="contractStatus"
                    :orderOverdueInterestList="orderOverdueInterestList"
                  />
                </div>
              </el-tab-pane>
              <el-tab-pane label="关联合同" name="fourth">
                <div class="detail">
                  <relation-info
                    :isEdit="isEdit"
                    ref="relationInfo"
                    :defaultData="orderContractRelationshipList"
                    :contractStatus="contractStatus"
                  >
                  </relation-info>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-collapse-item>
      <!--备注-->
      <!-- <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            备注
          </div>
        </template>
        <div class="collapse-content">
          <el-row :gutter="10" style="padding: 0 20px">
            <el-col :span="24">
              <el-form
                label-width="100px"
                ref="otherForm"
                :label-position="'right'"
                :model="remark"
              >
                <el-form-item
                  :label-width="
                    tabActiveName == 'third' || tabActiveName == 'five' ? '90px' : '40px'
                  "
                  :label="$t('salePurchase.other.remark')"
                  prop="mark"
                >
                  <el-input
                    :maxlength="256"
                    v-model="remark.mark"
                    :placeholder="$t('search.input')"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item> -->
      <!--附件-->
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <!-- <FileTable
            ref="fileTableRef"
            :attachments="attachments"
            :isShowDownBtn="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT051' &&
              contractStatus != 'ZT061'
            "
          /> -->
          <IEUploadFileType
            ref="fileTableRef"
            :tableData="attachments || []"
            @upload="handleUpload"
            :isShowDownBtn="
              contractStatus != '' &&
              contractStatus != 'ZT06' &&
              contractStatus != 'ZT05' &&
              contractStatus != 'ZT061'
            "
            dictType="CONTRACT_INITIATION"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮组 -->
    <ContractBtn @btnHandler="btnClickHandler" :contractStatus="contractStatus" />
  </div>
</template>
<script>
  // import formItem from '../components/form-item';
  // import product from '../components/product';
  import relationInfo from '../../components/relation-info';
  import API from '@/api/purchaseSalesCenter/purchaseSales.js';
  // import COM_API from '@/api/masterData/company.js';
  import AGENCY_API from '@/api/agencyContract/index';
  // import BASE_API from '@/api/dataBase.js';
  import { dateFormatter, delcommafy } from '@/common/js/util';
  // import { CHECK_EXTERNAL_CONTRACTNO } from '../components/checkExternalContractNo';
  import XEUtils from 'xe-utils';
  import saleAgreementCreationMixin from './saleAgreementCreationMixin.js';
  import BaseInfoContract from './components/BaseInfoContract/index.vue';
  import ShopDetailContractTable from './components/ShopDetailContractTable/index.vue';
  // import OverdueInterest from './components/OverdueInterest/index.vue';
  import OverdueInterestTable from './components/OverdueInterestTable/index.vue';
  import ContractBtn from './components/FooterBtnGroup/ContractBtn.vue';
  export default {
    name: 'saleContractCreation',
    components: {
      relationInfo,
      BaseInfoContract,
      ShopDetailContractTable,
      OverdueInterestTable,
      ContractBtn,
    },
    mixins: [saleAgreementCreationMixin],
    data() {
      return {
        isSales: true, //销售是sales，采购是purchase,标志符true代表传sales
        disabledIsRestrict: false, // 是否禁用限数
        activeNames: ['1', '2', '3'],
        tabActiveName: 'first',
        pricingRule: true,
        pricingRuleDisabled: false,
        //赊销金额是否必填
        creditAmountDisabled: false,
        deletedTableIds: [],
        params: {
          contractNo: null,
          tradeType: 'MY01',
          businessType: 'YDYW01',
          externalContractNo: null,
          contractCreateDate: dateFormatter(new Date()),
          contractBusinessDepartment: null,
          contractBusinessDepartmentName: null,
          contractOperaterNo: null,
          contractOperaterName: null,
          contractSalesman: null,
          contractSalesmanNo: null,
          contractSalesmanName: null,
          customer: null,
          customerNo: null,
          customerName: null,
          customerType: null,
          contractCurrency: '',
          contractCurrencyName: '',
          contractCurrencyExchangeRate: 1,
          companyCurrency: null, //公司本币
          companyCurrencyName: null,
          supplierNo: null,
          supplierName: null,
          isCreditsale: 1,
          isInsure: 1,
          isHedging: 1,
          isFixedPrice: 0,
          payerNo: null,
          payerName: null,
          receiptMethod: null,
          receiptCondition: null,
          pricingRule: null,
          supplychain: null,
          supplychainNo: null,
          supplychainName: null,
          creditAmount: undefined,
          contractTotalAmount: null,
          businessOrder: null,
          overShippedPercentage: null,
          shortShippedPercentage: null,
          lastestReceiveMoneyDay: null,
          lastestSendProductDay: null,
          performancePeriod: null,
          isNotProxy: null, //贸易合同-非代理,1-是,0-否'
          orderDetailList: [],
          otherInfo: {},
          orderInterest: {},
          orderDelivery: {},
          orderContractRelationshipList: [],
          orderSalesExport: {},
        },
        localCurrency: {}, //本币
        remark: {
          mark: null,
        },
        //附件
        uploadTableData: [],
        load: false,
        selectCompanyCode: '',
        attachments: [],
        contractTotalAmount: 0,
        isFixedPrice: null,
        companyCode: '',
      };
    },
    computed: {
      isEdit() {
        return this.$route.query.isEdit ? JSON.parse(this.$route.query.isEdit) : false;
      },
      // columns() {
      //   return [
      //     //合同编号1
      //     {
      //       prop: 'contractNo',
      //       name: this.$t('salePurchase.search.contractNo'),
      //       type: 'input',
      //       disabled: true,
      //       placeholder: this.$t('salePurchase.search.addContractNoPlaceholder'),
      //     },
      //     //制单日期2
      //     {
      //       prop: 'contractCreateDate',
      //       name: this.$t('salePurchase.search.purchaseCreateDate'),
      //       type: 'date',
      //       disabled: true,
      //     },
      //     //合同名称3fixme
      //     {
      //       prop: 'contractName',
      //       name: '合同名称',
      //       type: 'input',
      //       disabled: true,
      //       placeholder: '请输入合同名称',
      //     },
      //     //币种4
      //     {
      //       prop: 'contractCurrency',
      //       type: 'ajaxSelect',
      //       name: this.$t('salePurchase.search.purchaseCurrency'),
      //       apiUrl: AGENCY_API.LIST_CURRENCY,
      //       method: 'get',
      //       apiData: { isEnabled: 1 },
      //       valueKey: 'currencyCode',
      //       moreShowKey: 'currencyCode',
      //       labelKey: 'currencyName',
      //       valueType: 'object',
      //       changeMethod: 'changeCurrency',
      //     },
      //     //项目编号5fixme
      //     // {
      //     //   //项目
      //     //   field: 'projectCode',
      //     //   title: '项目',
      //     //   width: 120,
      //     //   ...{
      //     //     editRender: { name: 'ElInput', props: { clearable: true } },
      //     //     slots: {
      //     //       default: ({ row }) => {
      //     //         return [<span>{row.projectName}</span>];
      //     //       },
      //     //       edit: ({ row }) => {
      //     //         return [
      //     //           <search-table
      //     //             searchType="project"
      //     //             isMultiple={true}
      //     //             currentValue={row['projectName']}
      //     //             checkRowKeys={[row['projectCode']]}
      //     //             onInput={(val) => this.updateCol(row, val, 'projectCode')}
      //     //           ></search-table>,
      //     //         ];
      //     //       },
      //     //     },
      //     //   },
      //     // },
      //     //项目简称6fixme
      //     {
      //       prop: 'contractAbbreviation',
      //       name: '项目简称',
      //       type: 'input',
      //       disabled: true,
      //       placeholder: '请输入项目简称',
      //     },
      //     //业务部门7
      //     {
      //       prop: 'contractBusinessDepartment',
      //       name: this.$t('salePurchase.search.contractBusinessDepartment'),
      //       type: 'ajaxSelect',
      //       apiUrl: BASE_API.GET_PERSON_API,
      //       apiData: {
      //         id: this.userInfo.userCode,
      //         userCode: this.userInfo.userCode,
      //         personName: this.userInfo.userName,
      //         personCompanyCode: this.params.supplierNo,
      //       },
      //       dataString: 'data.personDepartmentInfo',
      //       valueKey: 'personDepartmentCode',
      //       labelKey: 'personDepartmentName',
      //       valueType: '',
      //       clearable: true,
      //       changeMethod: 'changeCurrency',
      //     },
      //     //负责人8fixme
      //     {
      //       prop: 'chargePerson',
      //       type: 'searchTableSpec',
      //       name: '负责人',
      //       searchType: 'personnel',
      //       isNeedMultipleValue: false,
      //       isMultiple: true,
      //       // isNeedMultipleValue: true,
      //     },
      //     //合同签署日期9fixme
      //     {
      //       prop: 'consignDate',
      //       name: '合同部署日期',
      //       type: 'date',
      //       changeMethod: 'changeCurrency',
      //     },
      //     //合同生效日期10fixme
      //     {
      //       prop: 'contractValidStartDate',
      //       name: '合同生效日期',
      //       type: 'startDaterangePicker',
      //     },
      //     //合同到期日期11fixme
      //     {
      //       prop: 'contractValidEndDate',
      //       name: '至',
      //       type: 'endDaterangePicker',
      //     },
      //     //合同总金额12fixme
      //     {
      //       prop: 'contractTotalAmount',
      //       name: this.$t('salePurchase.search.contractTotalAmount'),
      //       type: 'inputNumber',
      //       max: '99999999999.999999',
      //       placeholder: this.$t('salePurchase.search.contractTotalAmountPlaceholder'),
      //       disabled: true,
      //     },
      //     //公司名称13fixme
      //     {
      //       //申请单公司代码
      //       prop: 'businessCompanyCode',
      //       type: 'select',
      //       options: this.companyList,
      //       label: '公司名称',
      //       clearable: true,
      //       required: true,
      //     },
      //     //客户名称14
      //     {
      //       prop: 'customer',
      //       name: this.$t('salePurchase.search.customer'),
      //       type: 'searchTableSpec',
      //       searchType: 'supplier',
      //       extraData: {
      //         partnerTypes: 'HZHB03,HZHB01',
      //         companyCode: this.params.contractBusinessCompanyNo,
      //         departmentCode: this.params.contractBusinessDepartment,
      //       },
      //       currentValue: this.params.customerName ? this.params.customerName : null,
      //       checkRowKeys: [this.params.customerNo ? this.params.customerNo : null],
      //       isMultiple: true,
      //       changeMethod: 'changeCurrency',
      //     },
      //     //不定价15
      //     {
      //       prop: 'isFixedPrice',
      //       name: this.$t('salePurchase.search.isFixedPrice'),
      //       type: 'checkbox',
      //       falseLable: 0,
      //       trueLable: 1,
      //       disabled: true,
      //       changeMethod: 'changeCurrency',
      //     },
      //     //定价模式16
      //     {
      //       prop: 'pricingRule',
      //       name: this.$t('salePurchase.search.pricingRule'),
      //       type: 'ajaxSelect',
      //       clearable: true,
      //       apiUrl: BASE_API.DIC_CREDIT_API,
      //       apiData: { dictType: 'pricing_rule' },
      //       placeholder: this.$t('salePurchase.search.pricingRulePlaceholder'),
      //       disabled: this.pricingRuleDisabled,
      //       changeMethod: 'changeCurrency',
      //     },
      //     //回收公司档案编号17fixme
      //     {
      //       prop: 'recycleCompanyCode',
      //       name: '回收公司档案编号',
      //       type: 'input',
      //       disabled: true,
      //       placeholder: '请输入档案编号',
      //     },
      //     //回收公司18fixme
      //     {
      //       prop: 'recycleCompanyName',
      //       name: '回收公司',
      //       type: 'input',
      //       disabled: true,
      //       placeholder: '请输入回收公司',
      //     },
      //     //平台公司档案编号19fixme
      //     {
      //       prop: 'platformCompanyCode',
      //       name: '平台公司档案编号',
      //       type: 'input',
      //       disabled: true,
      //       placeholder: '请输入公司编号',
      //     },
      //     //平台公司20fixme
      //     {
      //       prop: 'platformCompanyName',
      //       name: '平台公司',
      //       type: 'input',
      //       disabled: true,
      //       placeholder: '请输入平台公司',
      //     },
      //     //溢装比例21
      //     {
      //       prop: 'overShippedPercentage',
      //       name: this.$t('salePurchase.search.overShippedPercentage'),
      //       type: 'inputNumber',
      //       max: '100.00',
      //       precision: this.$globalVar.iPoint,
      //       placeholder: this.$t('salePurchase.search.overShippedPercentagePlaceholder'),
      //       append: '%',
      //     },
      //     //短装比例22
      //     {
      //       prop: 'shortShippedPercentage',
      //       name: this.$t('salePurchase.search.shortShippedPercentage'),
      //       type: 'inputNumber',
      //       max: '100.00',
      //       precision: this.$globalVar.iPoint,
      //       placeholder: this.$t('salePurchase.search.shortShippedPercentagePlaceholder'),
      //       append: '%',
      //     },
      //     //保供条款23fixme
      //     {
      //       prop: 'warrantyClause',
      //       name: '保供条款',
      //       type: 'input',
      //       disabled: true,
      //       placeholder: '请输入',
      //     },
      //     //收款方式24
      //     {
      //       prop: 'receiptMethod',
      //       name: this.$t('salePurchase.search.collectMethod'),
      //       type: 'ajaxSelect',
      //       apiUrl: BASE_API.DIC_CREDIT_API,
      //       apiData: { dictType: 'payment_method' },
      //       placeholder: this.$t('salePurchase.search.collectMethodPlaceholder'),
      //     },
      //     //履约保证金缴纳方式25fixme
      //     {
      //       prop: 'depositPaymentMethod',
      //       name: '履约保证金缴纳方式',
      //       type: 'ajaxSelect',
      //       apiUrl: BASE_API.DIC_CREDIT_API,
      //       apiData: { dictType: 'payment_method' },
      //       placeholder: '请输入',
      //     },
      //     //履约保证金26fixme
      //     {
      //       prop: 'depositAmount',
      //       name: '履约保证金',
      //       type: 'inputNumber',
      //       precision: this.$globalVar.aPoint,
      //       max: '99999999999.999999',
      //       placeholder: '请输入',
      //       changeMethod: 'changeCurrency',
      //     },
      //     //操作人27
      //     {
      //       prop: 'contractOperaterName',
      //       name: this.$t('salePurchase.search.contractOperaterNo'),
      //       type: 'input',
      //       disabled: true,
      //     },

      //     //   {
      //     //     prop: 'tradeType',
      //     //     name: this.$t('salePurchase.search.tradeType'),
      //     //     type: 'ajaxSelect',
      //     //     clearable: true,
      //     //     apiUrl: BASE_API.DIC_CREDIT_API,
      //     //     apiData: { dictType: 'sale-trade-type' },
      //     //     placeholder: this.$t('salePurchase.search.tradeTypePlaceholder'),
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'businessType',
      //     //     name: this.$t('salePurchase.search.businessType'),
      //     //     type: 'ajaxSelect',
      //     //     clearable: false,
      //     //     apiUrl: BASE_API.DIC_CREDIT_API,
      //     //     apiData: { dictType: 'purchase_business_type' },
      //     //     placeholder: this.$t('salePurchase.search.businessTypePlaceholder'),
      //     //   },
      //     //   {
      //     //     prop: 'externalContractNo',
      //     //     name: this.$t('salePurchase.search.externalContractNo'),
      //     //     type: 'input',
      //     //     maxlength: 50,
      //     //     placeholder: this.$t('salePurchase.search.externalContractNoPlaceholder'),
      //     //   },
      //     //   {
      //     //     prop: 'contractSalesman',
      //     //     name: this.$t('salePurchase.search.contractSalesmanNo'),
      //     //     type: 'searchTableSpec',
      //     //     searchType: 'personnel',
      //     //     currentValue: this.params.contractSalesmanName
      //     //       ? this.params.contractSalesmanName
      //     //       : null,
      //     //     checkRowKeys: [this.params.contractSalesmanNo ? this.params.contractSalesmanNo : null],
      //     //     isMultiple: true,
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'customerType',
      //     //     name: this.$t('salePurchase.search.customerType'),
      //     //     type: 'ajaxSelect',
      //     //     clearable: false,
      //     //     disabled: true,
      //     //     apiUrl: BASE_API.DIC_CREDIT_API,
      //     //     apiData: { dictType: 'supplier_type' },
      //     //   },
      //     //货币
      //     //汇率
      //     //   {
      //     //     prop: 'contractCurrencyExchangeRate',
      //     //     name: this.$t('salePurchase.search.contractCurrencyExchangeRate'),
      //     //     type: 'input',
      //     //     disabled: this.params.contractCurrency == this.params.companyCurrency,
      //     //   },
      //     //   {
      //     //     prop: 'supplierNo',
      //     //     name: this.$t('salePurchase.search.supplierNo'),
      //     //     type: 'select',
      //     //     placeholder: this.$t('salePurchase.search.companyCodePlaceholder'),
      //     //     value: 'personCompanyCode',
      //     //     label: 'personCompanyName',
      //     //     options: JSON.parse(this.userInfo.companyList),
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'isCreditsale',
      //     //     name: this.$t('salePurchase.search.isCreditsale'),
      //     //     type: 'checkbox',
      //     //     falseLable: 0,
      //     //     trueLable: 1,
      //     //     moreBtn: true,
      //     //     key: 'creditList',
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'creditAmount',
      //     //     name: this.$t('salePurchase.search.creditsaleAmount'),
      //     //     type: 'inputNumber',
      //     //     precision: this.$globalVar.aPoint,
      //     //     max: '99999999999.999999',
      //     //     placeholder: this.$t('salePurchase.search.creditsaleAmountPlaceholder'),
      //     //     disabled: this.creditAmountDisabled,
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'isInsure',
      //     //     name: this.$t('salePurchase.search.isInsure'),
      //     //     type: 'checkbox',
      //     //     falseLable: 0,
      //     //     trueLable: 1,
      //     //   },
      //     //   {
      //     //     prop: 'isHedging',
      //     //     name: this.$t('salePurchase.search.isHedging'),
      //     //     type: 'checkbox',
      //     //     falseLable: 0,
      //     //     trueLable: 1,
      //     //   },
      //     //   {
      //     //     prop: 'payerName',
      //     //     name: this.$t('salePurchase.search.payerName'),
      //     //     maxlength: 50,
      //     //     type: 'input',
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'receiptCondition',
      //     //     name: this.$t('salePurchase.search.collectCondition'),
      //     //     type: 'input',
      //     //     maxlength: '100',
      //     //     //apiUrl: BASE_API.DIC_CREDIT_API,
      //     //     //apiData: { dictType: "receipt_condition" },
      //     //     placeholder: this.$t('salePurchase.search.collectConditionPlaceholder'),
      //     //   },
      //     //   {
      //     //     prop: 'supplychain',
      //     //     name: this.$t('salePurchase.search.supplychain'),
      //     //     type: 'searchTableSpec',
      //     //     searchType: 'supplychain',
      //     //     currentValue: this.params.supplychainName ? this.params.supplychainName : null,
      //     //     checkRowKeys: [this.params.supplychainNo ? this.params.supplychainNo : null],
      //     //     isMultiple: true,
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'lastestReceiveMoneyDay',
      //     //     name: this.$t('salePurchase.search.lastestReceiveMoneyDay'),
      //     //     type: 'date',
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'lastestSendProductDay',
      //     //     name: this.$t('salePurchase.search.lastestSendProductDay'),
      //     //     type: 'date',
      //     //     changeMethod: 'changeCurrency',
      //     //   },
      //     //   {
      //     //     prop: 'performancePeriod',
      //     //     name: this.$t('salePurchase.search.performancePeriodSale'),
      //     //     type: 'inputNumber',
      //     //     maxlength: '20',
      //     //     placeholder: this.$t('salePurchase.search.performancePeriodSalePlaceholder'),
      //     //   },
      //     //   {
      //     //     prop: 'isNotProxy',
      //     //     name: this.$t('salePurchase.search.isNotProxy'),
      //     //     type: 'checkbox',
      //     //     falseLable: 0,
      //     //     trueLable: 1,
      //     //   },
      //   ];
      // },
      // rules() {
      //   // 校验特殊字符
      //   var specialValidate = (rule, value, callback) => {
      //     var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
      //     if (value != null && value.match(reg)) {
      //       callback(new Error(this.$t('menu.emoticons')));
      //     } else if (value == null) {
      //       callback(new Error(this.$t('salePurchase.add.externalContractNoNotEmpty')));
      //     } else {
      //       callback();
      //     }
      //   };
      //   return {
      //     tradeType: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.tradeTypeNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     businessType: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.businessTypeNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     externalContractNo: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.externalContractNoNotEmpty'),
      //         validator: specialValidate,
      //         trigger: ['blur', 'change'],
      //       },
      //     ],
      //     purchaseCurrency: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.purchaseCurrencyNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     customer: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.customerNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     customerType: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.supplierTypeNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     pricingRule: [
      //       {
      //         required: this.pricingRule,
      //         message: this.$t('salePurchase.add.pricingRuleNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     creditAmount: [
      //       {
      //         required: !this.creditAmountDisabled,
      //         message: this.$t('salePurchase.add.creditAmountNotEmpty'),
      //         trigger: ['blur', 'change'],
      //       },
      //     ],
      //     contractCurrency: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.purchaseCurrencyNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     supplierNo: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.supplierNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     lastestReceiveMoneyDay: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.lastestReceiveMoneyDayNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     lastestSendProductDay: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.lastestSendProductDayNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     contractBusinessDepartment: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.contractBusinessDepartment'),
      //         trigger: 'change',
      //       },
      //     ],
      //     contractSalesman: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.contractSalesman'),
      //         trigger: 'change',
      //       },
      //     ],
      //     /* externalContractNo:[{
      //             required: true,
      //             message: this.$t(
      //               "salePurchase.add.externalContractNoNotEmpty"
      //             ),
      //             trigger: "change"
      //         }], */
      //     overShippedPercentage: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.overShippedPercentageNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     shortShippedPercentage: [
      //       {
      //         required: true,
      //         message: this.$t('salePurchase.add.shortShippedPercentageNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     supplychain: [
      //       {
      //         //若业务部门包含粮化，“供应链主体”字段为必填
      //         required: this.params.contractBusinessDepartmentName?.match(RegExp(/粮化/))
      //           ? true
      //           : false,
      //         message: this.$t('salePurchase.add.supplychainNotEmpty'),
      //         trigger: 'change',
      //       },
      //     ],
      //     //若业务部门包含粮化，宏佑，“外部合同号、业务订单、天数、直拨流向（采购合同）/交货地点（销售合同）、付款方式、付款条件（采购合同）/收款条件（销售合同）”字段为必填
      //     receiptMethod: [
      //       {
      //         required: this.params.contractBusinessDepartmentName?.match(RegExp(/粮化|宏佑/))
      //           ? true
      //           : false,
      //         message: '收款方式必填',
      //         trigger: 'change',
      //       },
      //     ],
      //     receiptCondition: [
      //       {
      //         required: this.params.contractBusinessDepartmentName?.match(RegExp(/粮化|宏佑/))
      //           ? true
      //           : false,
      //         message: '收款条件必填',
      //         trigger: 'change',
      //       },
      //     ],
      //     performancePeriod: [
      //       {
      //         required: this.params.contractBusinessDepartmentName?.match(RegExp(/粮化|宏佑/))
      //           ? true
      //           : false,
      //         message: '天数必填',
      //         trigger: 'change',
      //       },
      //     ],
      //   };
      // },
    },
    created() {
      //如果有合同号，说明是从别的合同或者协议创建的
      // if (this.$route.query.contractNo) {
      //   //获取详情
      //   this.getOrderDetail();
      // } else {
      //   //供应商
      //   this.params.supplierNo = this.userInfo.companyCode;
      //   this.params.supplierName = this.userInfo.companyName;
      //   //业务公司赋初值
      //   this.params.contractBusinessCompanyNo = this.userInfo.companyCode;
      //   this.params.contractBusinessCompanyName = this.userInfo.companyName;
      //   //业务部门赋初值
      //   this.params.contractBusinessDepartment = this.userInfo.departmentCode;
      //   this.params.contractBusinessDepartmentName = this.userInfo.departmentName;
      //   //操作人赋初值
      //   this.params.contractOperaterNo = this.userInfo.userCode;
      //   this.params.contractOperaterName = this.userInfo.userName;
      //   //业务员赋初值
      //   this.params.contractSalesmanNo = this.userInfo.userCode;
      //   this.params.contractSalesmanName = this.userInfo.userName;
      //   this.params.contractSalesman = [
      //     {
      //       contractSalesmanNo: this.userInfo.userCode,
      //       contractSalesmanName: this.userInfo.userName,
      //     },
      //   ];
      //   this.getLegerCode(this.params.supplierNo);
      // }
      // this.selectCompanyCode = this.userInfo.companyCode;
    },
    methods: {
      changeCompany(val) {
        console.log(val, '???');
        this.companyCode = val;
      },
      isDisabledIsRestrict(isDisabled) {
        this.disabledIsRestrict = isDisabled;
      },
      // 关闭明细表的时候计算金额
      closeTableHandler(tableData = []) {
        console.log(tableData, '===');
        const contractTotalAmount = tableData.reduce(
          (cur, next) => cur + +next.businessContractTotalAmount,
          0
        );
        // 处理表格中定价选择否的时候
        const isFixedPriceResult = tableData.some((item) => item.isFixedPrice == '0');
        // console.log(isFixedPriceResult, '--修改->>');
        //false 定价 true 不定价      1不定价 0定价
        this.isDisabledPricingRule = !isFixedPriceResult;
        this.isFixedPrice = isFixedPriceResult;
        this.contractTotalAmount = this.replaceZeroStr(Number(contractTotalAmount).toFixed(6));
        console.log(this.baseFormData, 'priceChanged', contractTotalAmount);
      },
      // 获取本币名称---供应商
      // async getLegerCode(companyCode) {
      //   if (companyCode) {
      //     let res = await this.$axios.get(API.GET_LEGER_CODE_NAME, { companyCode });
      //     if (res) {
      //       if (res.data.code == 0) {
      //         let data = res.data.data;
      //         if (data) {
      //           //本币
      //           this.params.companyCurrency = data.currencyCode;
      //           this.params.companyCurrencyName = data.currencyName;
      //           this.params.contractCurrency = this.params.companyCurrency;
      //           this.params.contractCurrencyName = this.params.companyCurrencyName;
      //           this.params.contractCurrencyExchangeRate = 1;
      //         } else {
      //           if (this.params.supplierNo == 'C0328') {
      //             this.params.contractCurrency = null;
      //             this.params.contractCurrencyName = null;
      //           }
      //           this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
      //         }
      //       } else {
      //         this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
      //       }
      //     } else {
      //       this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
      //     }
      //   }
      // },
      // getOrderDetail() {
      //   this.loading.startLoading();
      //   //copyFlag 1是合同创建合同  0是复制
      //   this.$axios
      //     .post(API.GET_ORDER_DETAIL_API, {
      //       contractNo: this.$route.query.contractNo,
      //       copyFlag: this.$route.query.copy ? '0' : '1',
      //       relationContractDetailCategory: 'HT07',
      //     })
      //     .then((res) => {
      //       this.loading.endLoading();
      //       if (res.data.code === 0) {
      //         this.params = Object.assign({}, this.params, res.data.data);
      //         this.selectCompanyCode = res.data.data.supplierNo || this.userInfo.companyCode;
      //         // this.params.orderDetailList.forEach(item=>{
      //         //   item.priceIdentity = 0
      //         // })
      //         //优惠信息是放在product组件里的，所以要单独赋值
      //         this.params.otherInfo = {
      //           isDiscount: res.data.data.isDiscount,
      //           priceExplain: res.data.data.priceExplain || null,
      //         };
      //         //是否不定价为否  则定价规则为必填
      //         if (this.params.isFixedPrice == 1) {
      //           this.pricingRule = true;
      //           this.pricingRuleDisabled = false;
      //         } else {
      //           this.pricingRule = false;
      //           this.pricingRuleDisabled = true;
      //         }
      //         //是否赊销  如果为是，则可填
      //         if (this.params.isCreditsale == 1) {
      //           this.creditAmountDisabled = false;
      //         } else {
      //           this.creditAmountDisabled = true;
      //         }
      //         //客户
      //         this.params.customer = [
      //           {
      //             customerNo: res.data.data.customerNo || null,
      //             customerName: res.data.data.customerName || null,
      //           },
      //         ];
      //         //业务员
      //         this.params.contractSalesman = [
      //           {
      //             contractSalesmanNo: res.data.data.contractSalesmanNo || null,
      //             contractSalesmanName: res.data.data.contractSalesmanName || null,
      //           },
      //         ];
      //         //供应链主体
      //         this.params.supplychain = [
      //           {
      //             supplychainNo: res.data.data.supplychainNo || null,
      //             supplychainName: res.data.data.supplychainName || null,
      //           },
      //         ];
      //         //操作人 和制单日期默认当前登录人和当天
      //         this.params.contractOperaterNo = this.userInfo.userCode;
      //         this.params.contractOperaterName = this.userInfo.userName;
      //         this.params.contractCreateDate = dateFormatter(new Date());
      //         //业务部门赋初值
      //         this.params.contractBusinessDepartment =
      //           res.data.data.contractBusinessDepartment || this.userInfo.departmentCode;
      //         this.params.contractBusinessDepartmentName =
      //           res.data.data.contractBusinessDepartmentName || this.userInfo.departmentName;
      //         //业务员赋初值
      //         this.params.contractSalesmanNo = this.userInfo.userCode;
      //         this.params.contractSalesmanName = this.userInfo.userName;
      //         //备注
      //         this.remark.mark = res.data.data.mark ? res.data.data.mark : null;
      //         // this.getLegerCode(this.params.supplierNo);
      //         // this.$nextTick(() => {
      //         //   this.$refs.formItem.clearValidate();
      //         // });
      //       } else {
      //         this.$alert(res.data.msg);
      //       }
      //     });
      // },
      //更换币种
      changeCurrency(obj) {
        //业务部门
        if (obj.prop == 'contractBusinessDepartment') {
          this.params.customer = null;
          this.params.customerNo = null;
          this.params.customerName = null;
          this.params.customerType = null;
          this.params.payerNo = null;
          this.params.payerName = null;
        }
        //贸易类型
        if (obj.prop == 'tradeType') {
          //更改贸易类型，需要更新产品明细表
          this.$refs.product.updateProduct(obj);
          //更改贸易类型，需要出口明细表
          this.$refs.exportInfo.updateProduct(obj);
        }
        //业务员
        if (obj.prop == 'contractSalesman') {
          this.params.contractSalesmanNo = obj.val ? obj.val[0].id : null;
          this.params.contractSalesmanName = obj.val ? obj.val[0].personName : null;
        }
        //客户-默认为付款单位
        if (obj.prop == 'customer') {
          //客户
          // this.params.customer = obj.val ? obj.val[0].partnerZhName : null;
          this.params.customerNo = obj.val ? obj.val[0].partnerCode : null;
          this.params.customerName = obj.val ? obj.val[0].partnerZhName : null;
          this.params.customer = [
            {
              customerNo: this.params.customerNo,
              customerName: this.params.customerName,
            },
          ];
          //付款单位
          this.params.payerNo = obj.val ? obj.val[0].partnerCode : null;
          this.params.payerName = obj.val ? obj.val[0].partnerZhName : null;
          //客户类别
          this.params.customerType = obj.val ? obj.val[0].partnerForm : null;
        }
        //付款单位如果修改了，将付款单位no置为空
        if (obj.prop == 'payerName') {
          this.params.payerNo = null;
          if (this.params.customer && obj.val == this.params.customer[0].partnerZhName) {
            this.params.payerNo = this.params.customer[0].partnerCode;
          }
        }
        //供应商
        if (obj.prop == 'supplierNo') {
          this.params.contractBusinessDepartment = null;
          this.params.contractBusinessDepartmentName = null;
          this.params.customer = null;
          this.params.customerNo = null;
          this.params.customerName = null;
          this.params.customerType = null;
          this.localCurrency = {};
          let item = XEUtils.find(
            JSON.parse(this.userInfo.companyList),
            (item) => item['personCompanyCode'] === obj.val
          );
          this.params.supplierNo = obj?.val;
          this.params.supplierName = item?.personCompanyName;
          //业务公司取值供应商字段，跟部门联动
          this.params.contractBusinessCompanyNo = this.params.supplierNo;
          this.params.contractBusinessCompanyName = this.params.supplierName;
          this.params.orderDetailList = [];
          this.selectCompanyCode = item.personCompanyCode;
          this.$refs.product.removeEvent();
          this.$refs.formItem.getDepartmentList();
          this.getLegerCode(this.params.supplierNo).then(() => {
            this.params.contractCurrency = this.params.companyCurrency;
            this.params.contractCurrencyName = this.params.companyCurrencyName;
          });
        }
        //定价规则
        if (obj.prop == 'isFixedPrice') {
          if (obj.val == 0) {
            this.pricingRule = false;
            this.pricingRuleDisabled = true;
          } else {
            this.pricingRule = true;
            this.pricingRuleDisabled = false;
          }
        }
        //供应链主体
        if (obj.prop == 'supplychain') {
          this.params.supplychainNo = obj.val ? obj.val[0].supplierCode : null;
          this.params.supplychainName = obj.val ? obj.val[0].supplierName : null;
        }
        //币种
        if (obj.prop == 'contractCurrency') {
          this.params.contractCurrency = obj.val.currencyCode || this.params.companyCurrency;
          this.params.contractCurrencyName =
            obj.val.currencyName || this.params.companyCurrencyName;
          const params = {
            fromCurrencyCode: this.params.contractCurrency,
            toCurrencyCode: this.params.companyCurrency,
          };
          //如果没有本位币
          if (this.params.supplierNo == 'C0328') {
            this.params.contractCurrency = null;
            this.params.contractCurrencyName = null;
            this.$message({
              showClose: true,
              message: '请先配置公司帐套',
              type: 'error',
            });
            return;
          }
          //如果是本币
          if (obj.val.currencyCode == this.params.companyCurrency) {
            this.params.contractCurrencyExchangeRate = 1;
            return;
          }
          if (!params.toCurrencyCode) {
            return;
          }
          //增加入参汇率类型exchangeType: Cooperate  公司类型  User 用户类型，除收付款单据其他汇率日期exchangeDate取月初日期
          params.exchangeType = 'Cooperate';
          params.exchangeDate = this.$baseRequest.getBeginOfMonth(new Date());
          this.$axios.post(AGENCY_API.GET_CURRENCY_EXCHANGE, params).then((res) => {
            if (res.data.code === 0) {
              if (res.data.data) {
                this.params.contractCurrencyExchangeRate = res.data.data.positiveRate;
                //更新运输信息的本币信息
                this.$refs.transportInfo.updateProduct(obj);
              }
            } else {
              this.$alert(res.data.msg);
              this.params.contractCurrencyExchangeRate = 1;
              this.params.contractCurrency = this.params.companyCurrency;
              this.params.contractCurrencyName = this.params.companyCurrencyName;
            }
          });
        }
        //是否赊销
        if (obj.prop == 'isCreditsale') {
          if (obj.val == 0) {
            this.creditAmountDisabled = true;
            this.params.creditAmount = '';
          } else {
            this.creditAmountDisabled = false;
            this.params.creditAmount = delcommafy(this.params.contractTotalAmount);
          }
        }
        //定价规则  一口价
        if (obj.prop == 'pricingRule') {
          if (obj.val == 'DJ02') {
            this.$refs.product.upDataPricingRule();
          }
        }
        // if(obj.prop == "creditAmount"){
        //    if(this.params.isCreditsale){
        //      this.params.contractTotalAmount = obj.val
        //    }
        // };
        //信用额度
        if (obj.val == 'creditList') {
          if (!this.params.customer) {
            this.$message({
              showClose: true,
              message: this.$t('salePurchase.noCustomer'),
              type: 'error',
            });
            return;
          }
          let path = {
            path: '/credit/statisticsList',
            name: 'creditStatisticsList',
            meta: {
              keepAlive: true,
              title: '信用额度统计',
            },
            query: {
              partnerCode: this.params.customerNo,
              validDate: dateFormatter(new Date()),
              accountTypes: this.params.isCreditsale == 1 ? ['ZK02', 'ZK03'] : [],
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        }
        //最晚收款日
        if (obj.prop == 'lastestReceiveMoneyDay') {
          //更新利息计算的逾期日期
          this.$refs.calculationInterest.updateProduct(obj);
        }
        //最晚发货日期
        if (obj.prop == 'lastestSendProductDay') {
          //更新运输信息的最迟装船日期和最迟交货日期
          this.$refs.transportInfo.updateProduct(obj);
        }
      },
      //设置不定价 或者 更新意向单总金额
      changeTableData(obj) {
        if (obj.label === 'isFixedPrice') {
          if (obj.value == 1) {
            this.pricingRule = true;
            this.pricingRuleDisabled = false;
          }
          if (obj.value == 0) {
            this.pricingRule = false;
            this.pricingRuleDisabled = true;
          }
        }
        if (obj.label === 'creditAmount') {
          if (!this.creditAmountDisabled) {
            this.$refs.formItem.setSearchModal(obj.label, obj.value);
          } else {
            return;
          }
        }
        this.$refs.formItem.setSearchModal(obj.label, obj.value);
      },
      //上传回调
      // handleUpload(uploadTableData) {

      //   this.uploadTableData = uploadTableData;
      // },
      // //保存
      // async handleSave(type) {
      //   if (type === '1') {
      //     let result = true;
      //     await this.$refs.upload.checkRequired().then((res) => {
      //       result = res;
      //     });
      //     if (!result) return;
      //   }
      //   const that = this;
      //   //基本信息-验证
      //   const base = this.$refs.formItem.submit(type);
      //   //产品明细-验证
      //   const product = this.$refs.product.submit(type);
      //   //如果贸易类型为出口或转口时，出口国别和销售国别必填
      //   const speak = this.$refs.exportInfo.submit(type);
      //   speak
      //     .then(() => {})
      //     .catch(() => {
      //       this.$message({
      //         showClose: true,
      //         message: this.$t('salePurchase.exportport'),
      //         type: 'error',
      //       });
      //     });
      //   //获取产品明细
      //   const goodsList = this.$refs.product.getValues();
      //   if (goodsList.length == 0) {
      //     this.$message({
      //       showClose: true,
      //       message: this.$t('xTable.saveNoData'),
      //       type: 'error',
      //     });
      //     return;
      //   }
      //   if (this.params.companyCurrency == null && type == '1') {
      //     this.$message({
      //       showClose: true,
      //       message: this.$t('salePurchase.companyCurrencyEmpty'),
      //       type: 'error',
      //     });
      //     return;
      //   }

      //   Promise.all([base, product, speak]).then(async () => {
      //     // 获取基础信息值
      //     const baseData = this.$refs.formItem.getValues();
      //     //合计信息
      //     const allTotal = this.$refs.product.getTotal();
      //     //获取爱他信息
      //     const otherInfo = this.$refs.product.getOtherValues();
      //     //purchase 采购 sales 销售
      //     baseData.contractCategory = 'sales';
      //     //制单类型
      //     baseData.contractDetailCategory = this.$route.query.type;
      //     //0 保存  1 提交
      //     baseData.type = type;
      //     //商品行项目
      //     baseData.orderDetailList = goodsList;
      //     //利息计算
      //     baseData.orderInterest = this.$refs.calculationInterest.getValues();
      //     //订单运输信息
      //     baseData.orderDelivery = this.$refs.transportInfo.getValues();
      //     //订单关联明细
      //     baseData.orderContractRelationshipList = this.$refs.relationInfo.getValues();
      //     //出口明细
      //     baseData.orderSalesExport = this.$refs.exportInfo.getValues();
      //     //附件信息
      //     const attachment = that.uploadTableData.map((item, index) => {
      //       const result = Object.assign(
      //         {},
      //         {
      //           sortNo: index,
      //         },
      //         item
      //       );
      //       return result;
      //     });
      //     //附件信息
      //     baseData.attachmentList = attachment;
      //     //如果是提交  需要校验合同金额不能为0
      //     if (baseData.contractTotalAmount == 0 || !baseData.contractTotalAmount) {
      //       this.$message({
      //         showClose: true,
      //         message: '合同总金额不能为0',
      //         type: 'error',
      //       });
      //       return;
      //     }
      //     //备注
      //     baseData.mark = this.remark.mark;
      //     const data = Object.assign({}, baseData, allTotal);
      //     const params = Object.assign({}, data, otherInfo);
      //     params.dataGroup = this.$globalVar.dataGroup;
      //     let numberList = [];
      //     baseData.orderDetailList.forEach((item) => {
      //       if (item.unit == 'KG' || item.unit == 'T') {
      //         let unitObject = {
      //           productQuantity: item.productQuantity,
      //           productUnit: item.unit,
      //         };
      //         numberList.push(unitObject);
      //       }
      //     });
      //     let checkParams = {
      //       id: baseData.id,
      //       dataGroup: this.$globalVar.dataGroup,
      //       externalContractNo: baseData.externalContractNo,
      //       contractCategory: 'sales',
      //       //itemType : baseData.externalContractNo,
      //     };
      //     const p1 = await CHECK_EXTERNAL_CONTRACTNO(checkParams);
      //     that.load = false;
      //     if (!p1) return;
      //     if (numberList.length > 0 && type == '1') {
      //       let query = {
      //         adds: numberList,
      //         businessDepartmentNo: this.params.contractBusinessDepartment,
      //         partnerType: 'HZHB01',
      //         partnerNo: this.params.payerNo,
      //         businessDepartmentName: this.params.contractBusinessDepartmentName,
      //       };
      //       that.load = true;
      //       that.$axios.post(API.BEFORE_SAVE_ORDER_API, query).then((res) => {
      //         this.load = false;
      //         if (0 == res.data.code) {
      //           this.getCheck(params, type);
      //         } else {
      //           this.$repeatConfirm(
      //             "<div><img src='/static/img/tips.png'/>" +
      //               "<div class='repeatContent'>" +
      //               res.data.msg +
      //               '</div></div>',
      //             '',
      //             {
      //               dangerouslyUseHTMLString: true,
      //               confirmButtonText: this.$t('salePurchase.message.submitAgain'),
      //               cancelButtonText: this.$t('confirm.cancel'),
      //               center: true,
      //               callback: (action) => {
      //                 if (action === 'confirm') {
      //                   this.getCheck(params, type);
      //                 } else {
      //                   this.$message({
      //                     type: 'info',
      //                     message: this.$t('salePurchase.message.gitUpSubmitAgain'),
      //                   });
      //                 }
      //               },
      //             }
      //           );
      //         }
      //       });
      //     } else {
      //       this.getCheck(params, type);
      //     }
      //   });
      // },
      //信用额度校验
      getCheck(saveParams, type) {
        const baseData = this.$refs.formItem.getValues();
        //合计信息
        const allTotal = this.$refs.product.getTotal();
        //信用额度
        if (type == '1' && baseData.isCreditsale == 1) {
          const contractNoList = [
            {
              businessDepartmentCode: baseData.contractBusinessDepartment, //业务部门
              contractNo: this.$route.query.contractNo, //合同号
              partnerCode: baseData.customerNo, //客户
              payAmount: allTotal.businessContractTotalAmount, //合同原币
              contractCurrency: baseData.contractCurrency, //币种
            },
          ];
          const params = {
            contractNoList: JSON.stringify(contractNoList),
          };
          this.load = true;
          this.$axios.post(API.CHECK_AVAILABLE_AMOUNT, params).then((res) => {
            this.load = false;
            if (0 != res.data.code) {
              this.$repeatConfirm(
                "<div><img src='/static/img/tips.png'/>" +
                  "<div class='repeatContent'>" +
                  '信用额度不足' +
                  '</div></div>',
                '',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('salePurchase.message.submitAgain'),
                  cancelButtonText: this.$t('confirm.cancel'),
                  center: true,
                  callback: (action) => {
                    if (action === 'confirm') {
                      this.saveImport(saveParams, type);
                    } else {
                      this.$message({
                        type: 'info',
                        message: this.$t('salePurchase.message.gitUpSubmitAgain'),
                      });
                    }
                  },
                }
              );
            } else {
              this.saveImport(saveParams, type);
            }
          });
        } else {
          this.saveImport(saveParams, type);
        }
      },
      saveImport(params, type) {
        this.load = true;
        this.$axios.post(API.SAVE_ORDER_API, params).then((res) => {
          this.load = false;
          if (10 === res.data.code) {
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                //确认提交，cancelValidate传值true取消校验
                params.cancelValidate = true;
                this.saveImport(params, type);
              },
            });
          } else if (0 != res.data.code) {
            if (!res.data.data) {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  params.cancelValidate = true;
                  this.saveImport(params, type);
                },
              });
            } else {
              this.$alert(res.data.msg);
              this.dblclickEvent(res.data.data);
            }
          } else {
            if (type == '0') {
              this.dblclickEvent(res.data.data);
            } else {
              this.cancel(false);
            }
            this.$message({
              showClose: true,
              message: res.data.msg || this.$t('message.success'),
              type: 'success',
            });
          }
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/salePurchase/singleSale',
            name: 'singleSale',
            meta: {
              keepAlive: true,
              title: '单次销售合同创建',
            },
          },
          toPath: {
            path: '/salePurchase/singleSaleEdit',
            name: 'singleSaleEdit',
            meta: {
              keepAlive: false,
              title: this.$t('salePurchase.message.singleSalesContractEdit'),
            },
            query: {
              id: value.id,
              type: value.contractDetailCategory,
              contractNo: value.contractNo,
              contractCategory: 'sales',
              isEdit: value.contractStatus === 'ZT03' ? true : false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //跳转到列表页面
      cancel(keepAlive) {
        let path = {
          fromPath: {
            path: '/salePurchase/singleSale',
            name: 'singleSale',
            meta: {
              keepAlive: true,
              title: this.$t('salePurchase.message.singleSalesContractCreation'),
            },
          },
          toPath: {
            path: '/salePurchase/saleOverview',
            name: 'saleOverview',
            meta: {
              keepAlive: keepAlive,
              title: this.$t('salePurchase.message.salesOverviewEnquiries'),
            },
            query: {
              contractDetailCategory: 'HT07',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .prodcut {
    margin-bottom: 11px;
    background-color: #fff;
  }

  .detail {
    padding-bottom: 0px;
  }

  .collapse-main-content {
    margin-bottom: 10px;
  }
</style>
